module.exports = __webpack_public_path__ + "img/hhep.24973dd9.svg";